import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'WORK', href: '#work' },
  { label: 'CAPABILITIES', href: '#capabilities' },
  { label: 'TEAM', href: '#team' },
  { label: 'ABOUT', href: '#about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-[#050505]/90 backdrop-blur-md border-b border-white/5'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1440px] mx-auto flex items-center justify-between px-6 md:px-10 py-5">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group">
            <div className="w-8 h-8 rounded-full border-2 border-emerald-500/60 flex items-center justify-center relative overflow-hidden">
              <span className="text-[10px] font-black text-emerald-400">G2</span>
            </div>
            <span className="font-mono text-sm font-bold tracking-[0.15em] uppercase text-white">
              GO2 MEDIA
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollTo(link.href)}
                className="font-mono text-xs tracking-[0.2em] text-white/50 hover:text-emerald-400 transition-colors duration-300 relative group"
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-emerald-500 group-hover:w-full transition-all duration-300" />
              </button>
            ))}
            <button
              onClick={() => scrollTo('#contact')}
              className="font-mono text-xs tracking-[0.15em] px-6 py-3 border border-emerald-500/40 text-emerald-400 rounded-full hover:bg-emerald-500 hover:text-black transition-all duration-300"
            >
              GET IN TOUCH
            </button>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="lg:hidden p-2 text-white"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 bg-[#050505] transition-transform duration-500 lg:hidden ${
          mobileOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col items-center justify-center h-full gap-8">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => scrollTo(link.href)}
              className="font-mono text-lg tracking-[0.3em] text-white/70 hover:text-emerald-400 transition-colors"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('#contact')}
            className="font-mono text-sm tracking-[0.15em] px-8 py-4 border border-emerald-500/40 text-emerald-400 rounded-full hover:bg-emerald-500 hover:text-black transition-all duration-300 mt-4"
          >
            GET IN TOUCH
          </button>
        </div>
      </div>
    </>
  );
}
